// import axios from 'axios';
import { useState, useCallback } from 'react';
import axiosInstance from '../axios/axiosInstance';

export function useFuncAtualizarDados() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const pathsCall = useCallback(async (id, data) => {
    setLoading(true);
    try {
      const res = await axiosInstance.patch(`atualizar/user/${id}/`, data);
      setResult({ sucess: true });
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        return setResult({ error: 'ERR_NETWORK' });
      }
      return setResult({ error: error.response.data });
    }
    setLoading(false);
  }, []);

  const resetInfo = () => {
    setResult('');
  };

  return { result, pathsCall, loading, resetInfo };
}

export function useCadastroUser() {
  const [loading, setLoading] = useState(false);

  const [result, setResult] = useState('');

  const pathsCall = useCallback(async (data) => {
    setLoading(true);
    try {
      const res = await axiosInstance.post(`cadastro/user/`, data);
      setResult({ sucess: true });
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        return setResult({ error: 'ERR_NETWORK' });
      }
      return setResult({ error: error.response.data });
    }
    setLoading(false);
  }, []);

  const resetInfo = () => {
    setResult('');
  };

  return { result, pathsCall, loading, resetInfo };
}
